import axios from "../../../axios"
import { paramsObjToGraphQLParams } from "@/utils/index.js"

export default {
  fetch(queryData) {
    return axios.post('', {
      query: `
        query {
          newspaperPdfs ${paramsObjToGraphQLParams(queryData)} {
            order_by,
            pagination_page,
            pagination_limit,
            total_pages,
            items {
              id,
              url,
              created_at,
              activated,
              schedule_publish_at,
            }
          }
        }
      `
    })
  },
  add(newspaperPdf) {
    return axios.post('', {
      query: `
        mutation {
          createNewspaperPdf (
            url: "${newspaperPdf.url}",
            schedule_publish_at: ${newspaperPdf.schedule_publish_at !== null ? `"${newspaperPdf.schedule_publish_at}"` : null}
          ) {
            id,
            url,
            created_at,
            activated,
            schedule_publish_at,
          }
        }
      `
    })
  },
  delete(newspaperPdfId) {
    return axios.post('', {
      query: `
        mutation {
          deleteNewspaperPdf (
            id: ${newspaperPdfId}
          )
        }
      `
    })
  },
  infos(newspaperPdfId) {
    return axios.post('', {
      query: `
        query {
          newspaperPdfInfos (
            id: ${newspaperPdfId}
          ) {
            id,
            url,
            created_at,
            activated,
            schedule_publish_at,
          }
        }
      `
    })
  }
}
